import axios from 'axios'
import * as utils from './apiUtils'

export default {
  index(params) {
    return axios.get(utils.getApiUrl('/tenken_data_rojou'), {
      params: params || {}
    })
  },
  search(params) {
    return axios.get(utils.getApiUrl('/tenken_data_rojou/search'), {
      params: params || {}
    })
  },
  create(params) {
    return axios.post(utils.getApiUrl('/tenken_data_rojou'), params)
  },
  show(id) {
    return axios.get(utils.getApiUrl(`/tenken_data_rojou/${id}`))
  },
  update(id, params) {
    return axios.put(utils.getApiUrl(`/tenken_data_rojou/${id}`), params)
  },
  delete(id) {
    return axios.delete(utils.getApiUrl(`/tenken_data_rojou/${id}`))
  },
  bulkUpdatePhotos(id, params) {
    return axios.post(utils.getApiUrl(`/tenken_data_rojou/${id}/bulk_update_photos`), params)
  },
  downloadHoshuReportCSV(params) {
    return axios.get('/tenken_data_rojou/download_hoshu_report_csv.csv', {
      params: params,
      responseType: 'blob',
    })
  },
  downloadSearchResultCSV(params) {
    return axios.get('/tenken_data_rojou/download_search_result_csv.csv', {
      params: params,
      responseType: 'blob',
    })
  },
  getDailyReport(params) {
    return axios.post(utils.getApiUrl('/tenken_data_rojou/get_daily_report'), params)
  },
  getMonthlyReport(params) {
    return axios.post(utils.getApiUrl('/tenken_data_rojou/get_monthly_report'), params)
  },
}
